import React from "react";
import PrintSafesMain from "../../Safes/PrintSafesMain";
import { Dialog } from "@material-ui/core";

export default function SanadsPrint(props) {
    const { dataPrint, closePrint, infoPrint } = props;
    const number=dataPrint?.isLarge?10:11;
    return (
        <Dialog
            fullScreen
            open={infoPrint}
            onClose={closePrint}
        >
            <div>
                <PrintSafesMain typePrint={number} docNamePdf={"Sanad.pdf"} docName={"Sanad"}
                    dataPrint={dataPrint} closePrint={closePrint} />
            </div>
        </Dialog>
    );
}
